<template>
  <section
    v-if="show"
    class="eds-alert"
    :class="[
      `alert-${motif}`,
      `alert-${background}`,
      {
        'alert-shadow': shadow,
        'alert-border': border,
      },
      alertClass,
    ]"
    :style="alertStyle"
  >
    <button
      aria-label="close"
      class="alert-close eds-link"
      @click="$emit('close')"
    >
      <slot name="closeIcon">
        <svg fill="currentColor" width="100%" height="100%" viewBox="0 0 24 24">
          <title>Close</title>
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
      </slot>
    </button>
    <div class="alert-content" :class="[contentClass]" :style="[contentStyle]">
      <span
        class="alert-title"
        :class="[{ 'title-compact': compact }, titleClass]"
        :style="[titleStyle]"
      >
        <slot name="title" />
      </span>
      <component
        :is="compact ? 'span' : 'p'"
        class="alert-message"
        :class="[messageClass]"
        :style="[messageStyle]"
      >
        <slot name="message" />
      </component>
    </div>
  </section>
</template>
<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Alert',
    emits: ['close'],
    props: {
      show: {
        type: Boolean,
        required: false,
        default: true,
      },
      motif: {
        type: String,
        required: false,
        default: 'info',
        validator: (value: string) => {
          return ['info', 'warn', 'error', 'success'].includes(value);
        },
      },
      background: {
        type: String,
        required: false,
        default: 'gray',
        validator: (value: string) => {
          return ['white', 'gray'].includes(value);
        },
      },
      compact: {
        type: Boolean,
        required: false,
        default: false,
      },
      border: {
        type: Boolean,
        required: false,
        default: false,
      },
      shadow: {
        type: Boolean,
        required: false,
        default: false,
      },
      alertClass: {
        type: String,
        required: false,
        default: '',
      },
      alertStyle: {
        type: Object,
        required: false,
      },
      contentClass: {
        type: String,
        required: false,
        default: '',
      },
      contentStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      titleClass: {
        type: String,
        required: false,
        default: '',
      },
      titleStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      messageClass: {
        type: String,
        required: false,
        default: '',
      },
      messageStyle: {
        type: Object,
        required: false,
      },
    },
    // methods: {
    //   close(): void {
    //     this.$emit('close');
    //   },
    // },
  });
</script>
<style></style>
